module.exports = __webpack_public_path__ + "img/highRoller.485b45eb.png";